export default class Menu {
  constructor() {
    this.this = '#main-menu'
    this.$this = $(this.this)
    this.$mainMenu = $('#main-menu').find('.main-menu-ul')
    this.elementItem = '.hamburger-menu, html, #main-menu, #header'
    this.$header = $('#header, #main-menu-mobile')
    this.$hamburgerMenu = $('.hamburger-menu')
    // Exclude has-sub > a so clicking the link text navigates normally.
    // .sub-arrow inside those links is handled separately in clickArrowOpenDropdownMenuLevel1.
    this.li = this.$this.find('.main-menu-ul >li:not(.has-sub)>a, .main-menu-ul >li>button')
    this.liLevel1 = this.$this.find('.main-menu-ul >li')
    this.liLevel2 = this.$this.find('.main-menu-ul .main-menu-dropdown li>a, .main-menu-ul .main-menu-dropdown li>button')
    this.isOpenMenu = 'is-open-menu'
    this.isOpenMenuChild = 'open-menu-child'
    this.isOpenChild = 'is-open-child'
    this.$linksInMenu = $('.header a:not(.skip-link), .header button')
    this.$firstLinkInMenu = this.$linksInMenu.first()
    this.$lastLinkInMenu = this.$linksInMenu.last()
    this.$skipLink = $('.header a.skip-link')
    this.ariaExpanded = 'aria-expanded'
    this.classHover = 'hovering'
  }

  init() {
    if (this.$this.length) {
      this.openMainMenu()
      this.clickArrowOpenDropdownMenuLevel1()
      this.clickLiOpenDropdownMenuLevel1()
      this.clickArrowOpenDropdownMenuLevel2()
      this.clickOutSite()
      this.clickLiOpenDropdownMenuLevel2()
      this.toggleTabIndexSkipLink()
      this.hoverOpenMenu()
      this.clickMobileBack()
    }
  }

  clickMobileBack() {
    this.$this.on('click', '.mobile-menu-back', (e) => {
      e.stopPropagation()
      const $li = $(e.currentTarget).closest('.menu-item')
      $li.removeClass(this.isOpenChild)
      $li.find('> a, > button').attr(this.ariaExpanded, false)
    })
  }

  /* micro function */
  microOpenCloseLevel1(currentElement, openClass, isLiLv1 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parent()
    if ($(window).width() < 1200) {
      if (eleParent.find('ul').length && !eleParent.hasClass(openClass)) {
        this.liLevel1.removeClass(openClass)
        this.liLevel1.find('> a, > button').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv1) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }
    return true
  }
  /* end micro */

  openMainMenu() {
    this.$header.on('click', '.hamburger-menu', (e) => {
      const ele = e.currentTarget

      if ($(ele).hasClass(this.isOpenMenu)) {
        $(this.elementItem).removeClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Open menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, false)
        this.$skipLink.removeAttr('tabindex')
      } else {
        $(this.elementItem).addClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Close menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, true)
        this.bindEventFocusOnMenu()
      }
    })
  }

  toggleTabIndexSkipLink() {
    $(window).on('resize', () => {
      if ($(window).outerWidth() < 1200) {
        this.$skipLink.removeAttr('tabindex')
      }
    })
  }

  bindEventFocusOnMenu() {
    this.$skipLink.attr('tabindex', -1)
    this.$firstLinkInMenu.get(0).addEventListener('keydown', this.shiftTabFocusToLast.bind(this))
    this.$lastLinkInMenu.get(0).addEventListener('keydown', this.tabFocusToFirst.bind(this))
  }

  tabFocusToFirst(e) {
    if (e.which === 9 && $(window).outerWidth() < 1200 && !e.shiftKey) {
      e.preventDefault()
      this.$firstLinkInMenu.focus()
    }
  }

  shiftTabFocusToLast(e) {
    if (e.which === 9 && $(window).outerWidth() < 1200 && e.shiftKey) {
      e.preventDefault()
      this.$lastLinkInMenu.focus()
    }
  }

  clickArrowOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', '.arrows-lv1', (e) => {
      this.microOpenCloseLevel1(e, this.isOpenChild)
    })

    // Click on .sub-arrow inside an <a> link (has-sub + has URL):
    // prevent navigation, stop bubbling, then open dropdown using the <a> as context.
    this.$this.find('.main-menu-ul li.has-sub > a.menu-item__link .sub-arrow').on('click.subArrow', (e) => {
      if ($(window).width() >= 1200) return
      e.preventDefault()
      e.stopPropagation()
      const $a = $(e.currentTarget).closest('a.menu-item__link')
      this.microOpenCloseLevel1({ currentTarget: $a[0] }, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel1() {
    this.li.on('click', (e) => this.microOpenCloseLevel1(e, this.isOpenChild, true))
  }

  clickArrowOpenDropdownMenuLevel2() {
    this.$this.find('.main-menu-ul').on('click', '.arrows-lv2', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      if ($(window).width() < 1200) {
        if (eleParent.find('.menu-child').length && !eleParent.hasClass(this.isOpenMenuChild)) {
          eleParent.addClass(this.isOpenMenuChild)
        } else {
          eleParent.removeClass(this.isOpenMenuChild)
        }
      }
    })
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest('#header.is-open-menu').length) {
        $(this.elementItem).removeClass(this.isOpenMenu)
      }
    })
  }

  clickLiOpenDropdownMenuLevel2() {
    this.liLevel2.on('click', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      if ($(window).width() < 1200 && eleParent.find('ul').length && !eleParent.hasClass(this.isOpenMenuChild)) {
        this.li.removeClass(this.isOpenMenuChild)
        eleParent.addClass(this.isOpenMenuChild)
        return false
      }
      return true
    })
  }

  closeAllSubmenu() {
    const $liHover = this.$this.find('.main-menu-ul>li.hovering')
    $liHover.removeClass('hovering')
    if ($liHover.hasClass('has-sub')) {
      $liHover.find('> a, > button').attr(this.ariaExpanded, false)
    }
  }

  /**
   * Desktop hover behavior for the main menu, with two UX safeguards:
   *
   * 1. hoverIntent-lite: open the dropdown only when the mouse slows down
   *    (velocity below OPEN_THRESHOLD_PX_PER_MS) or stalls past OPEN_MAX_WAIT_MS.
   *    Prevents accidental opens when the user is just sweeping across the bar.
   * 2. Close grace (CLOSE_GRACE_MS): single timer on mouseleave of the whole
   *    menu, cancelled if the user re-enters. Pairs with the invisible CSS
   *    bridge that covers the gap between trigger and dropdown.
   */
  hoverOpenMenu() {
    const classHoverHeader = 'pin-color'
    // Tuning knobs — adjust based on feel.
    const OPEN_THRESHOLD_PX_PER_MS = 0.35 // mouse must move slower than this to open
    const CLOSE_GRACE_MS = 150            // delay before closing after leaving the menu
    const OPEN_MAX_WAIT_MS = 150          // fallback: force open even if mouse stays fast

    let pendingOpenEl = null  // item queued for opening, awaiting slow-down
    let openRaf = null        // rAF handle for the open polling loop
    let closeTimer = null     // setTimeout handle for delayed close
    let lastX = 0
    let lastY = 0
    let lastT = 0
    let mouseVel = 0          // current mouse velocity in px/ms

    const isDesktop = () => $(window).outerWidth() >= 1200

    /**
     * Opens the dropdown for `ele`. Handles the special "mega → mega" switch
     * case by temporarily disabling transitions on both the outgoing and
     * incoming dropdowns — otherwise the parallel fade-out/fade-in creates a
     * window where total opacity drops below 1 and page content shows through.
     * Single ↔ mega switches keep their normal fade since only one dropdown is
     * involved.
     */
    const doOpen = (ele) => {
      const $currentHovering = this.$this.find(`.main-menu-ul > li.${this.classHover}`)
      // Instant switch only when BOTH the previous and the new item are mega
      // dropdowns. Otherwise let the regular CSS transition play.
      const isSwitching =
        $currentHovering.length > 0 &&
        !$currentHovering.is(ele) &&
        $currentHovering.hasClass('has-sub') &&
        $(ele).hasClass('has-sub')

      if (isSwitching) {
        $currentHovering.find('.main-menu-dropdown').addClass('no-transition')
        $(ele).find('.main-menu-dropdown').addClass('no-transition')
      }

      this.closeAllSubmenu()
      $(ele).addClass(this.classHover)
      if ($(ele).hasClass('has-sub')) {
        $(ele).find('> a, > button').attr(this.ariaExpanded, true)
      }
      this.$header.addClass(classHoverHeader)

      if (isSwitching) {
        // Double rAF: wait for the browser to commit the no-transition style,
        // then remove the class so subsequent open/close animations work
        // normally. A single rAF can be batched with the class change and
        // skipped.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            $('.main-menu-dropdown.no-transition').removeClass('no-transition')
          })
        })
      }
    }

    const cancelPendingOpen = () => {
      pendingOpenEl = null
      if (openRaf) {
        cancelAnimationFrame(openRaf)
        openRaf = null
      }
    }

    // Poll mouse velocity each frame. Open as soon as the mouse slows down,
    // or after OPEN_MAX_WAIT_MS as a fallback if it stays fast (e.g. user
    // really did want this menu but never paused).
    const scheduleOpen = (ele) => {
      cancelPendingOpen()
      pendingOpenEl = ele
      const start = performance.now()
      const tick = () => {
        if (pendingOpenEl !== ele) return
        const elapsed = performance.now() - start
        if (mouseVel < OPEN_THRESHOLD_PX_PER_MS || elapsed > OPEN_MAX_WAIT_MS) {
          doOpen(ele)
          pendingOpenEl = null
          openRaf = null
        } else {
          openRaf = requestAnimationFrame(tick)
        }
      }
      openRaf = requestAnimationFrame(tick)
    }

    const doClose = () => {
      this.closeAllSubmenu()
      this.$header.removeClass(classHoverHeader)
    }

    // Track mouse velocity (px/ms) across the menu bar for hoverIntent.
    this.$mainMenu.on('mousemove', (e) => {
      const now = performance.now()
      if (lastT) {
        const dx = e.clientX - lastX
        const dy = e.clientY - lastY
        const dt = Math.max(1, now - lastT)
        mouseVel = Math.hypot(dx, dy) / dt
      }
      lastX = e.clientX
      lastY = e.clientY
      lastT = now
    })

    this.liLevel1.on('mouseenter', (e) => {
      if (!isDesktop()) return
      // Re-entering cancels a pending close (user came back during grace).
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
      const ele = e.currentTarget
      if ($(ele).hasClass(this.classHover)) return
      scheduleOpen(ele)
    })

    // Leaving an item before it actually opened — cancel the pending open.
    this.liLevel1.on('mouseleave', (e) => {
      if (!isDesktop()) return
      if (pendingOpenEl === e.currentTarget) cancelPendingOpen()
    })

    // Leaving the whole menu bar — close after a short grace so quick
    // overshoots back into the menu don't trigger a close/open flicker.
    this.$mainMenu.on('mouseleave', () => {
      if (!isDesktop()) return
      cancelPendingOpen()
      if (closeTimer) clearTimeout(closeTimer)
      closeTimer = setTimeout(() => {
        doClose()
        closeTimer = null
      }, CLOSE_GRACE_MS)
    })

    $(window).on('keydown', (e) => {
      if (e.keyCode === 27 && isDesktop()) {
        cancelPendingOpen()
        if (closeTimer) {
          clearTimeout(closeTimer)
          closeTimer = null
        }
        doClose()
      }
    })
  }
}

new Menu().init()
